import { connect } from 'react-redux';

import InstitutionManager from './InstitutionManager.js';
// import { redux as apiRedux } from '../api';

const mapStateToProps = state => {
  return {
    user: state.api.user,
  };
};

const mapDispatchToProps = dispatch => {
  return {};
};

const ConnectedInstitutionManager = connect(
  mapStateToProps,
  mapDispatchToProps
)(InstitutionManager);

export default ConnectedInstitutionManager;
